import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../layout/Content'
import CustomersAccountsListController from '../customers_accounts_list/CustomersAccountsListController'
import CustomerAccountItemFooterStyle from './css/CustomerAccountItemFooterStyle'
import { appContext } from '../../../App'

function CustomerAccountItemFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  return (
    <ContentFooter>
      <div className='action-buttons-container'>
        <button
          onClick={() => setContent(<CustomersAccountsListController />)}
          className='pospro-action-btn'>
          <FontAwesomeIcon icon='list-alt'/>&nbsp;Back to Customer's Accounts List
        </button>
      </div>
      <CustomerAccountItemFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(CustomerAccountItemFooter)
